import { useEffect, useState } from "react";

import Layout from "../../components/layout";
import OpenGraphTwitterCard from "../../components/seo/OpenGraphTwitterCard";
import styles from "./pricing.module.scss";
import getCommonLocales from "../../locales/locales_common";
import getPricingLocale from "../../locales/locales_pricing";
import { getCurrency, getPlans } from "../api/api";
import PlansTable from "../../components/pricing/PlansTable/PlansTable";
import FaqComponent from "../../components/FaqComponent/FaqComponent";
import Head from "next/head";
import { useStore } from "../../stores/use_global_state";
import { Loading_ellipsis } from "../../components/loading";

export default function Pricing(props) {
	const { locale, query } = props;
	const { state } = useStore();
	const { accountData } = state;

	const [initialPlansProps, setInitialPlansProps] = useState({ initialPlans: null, initialProPlan: null, initialAnnually: null, locale: null });

	const dictionary = { ...getPricingLocale(locale), ...getCommonLocales(locale) };

	useEffect(
		() => {
			const fetchPlans = async () => {
				let currencyType = await getCurrency();
				if (query.currency) currencyType = query.currency;
				if (accountData?.subscription?.currency) currencyType = accountData?.subscription?.currency;
				let { data } = await getPlans(currencyType);
				data = data.filter((item) => item.variants === undefined && item.plan !== "premium");
				data.sort((a, b) => a.price - b.price);
				const initialAnnually = false;
				const period = "monthly";
				const proPlans = [...data.filter((item) => item.period === period)];
				const initialProPlan = proPlans[2];

				setInitialPlansProps({ initialPlans: data, initialProPlan: initialProPlan, initialAnnually: initialAnnually, locale: locale });
			};

			fetchPlans();
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[locale, accountData]
	);

	const getCanonicalLink = (locale) => {
		const enList = ["en", "ja", "ar"];

		if (enList.includes(locale)) {
			return `https://bgrem.ai/pricing/`;
		} else {
			return `https://bgrem.ai/${locale}/pricing/`;
		}
	};

	function cleanText(text) {
		// Remove all XML-like tags using regex
		let cleaned = text.replace(/<[^>]+>/g, '');

		// Replace \n with actual line breaks
		cleaned = cleaned.replace(/\\n/g, '\n');

		// Remove multiple consecutive line breaks
		cleaned = cleaned.replace(/\n{3,}/g, '\n\n');

		// Trim extra whitespace
		cleaned = cleaned.trim();

		return cleaned;
	}


	const schemaOrg = {
		"@context": "https://schema.org",
		"@type": "Product",
		"name": `${dictionary["page title"]} - BgRem`,
		"description": `${cleanText(dictionary["page_pricing_description"])}`,
		"url": `${getCanonicalLink(locale)}`,
		"brand": { "@type": "Brand", "name": "BgRem.ai" },
		"mainEntityOfPage": { "@type": "WebPage", "@id": `${getCanonicalLink(locale)}` }
	}

	return (
		<Layout>
			<Head>
				<script src="https://widget.cloudpayments.ru/bundles/cloudpayments.js" defer />
				<script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaOrg) }} />
			</Head>
			<OpenGraphTwitterCard title={`${dictionary["page title"]} - BgRem`} description={cleanText(dictionary["page_pricing_description"])} url={`${locale !== "en" ? locale + "/" : "/"}pricing`} canonical={getCanonicalLink(locale)} />
			<section className={styles.top}>
				<h1 className={styles.page_title}>{dictionary["page title"]}</h1>
				<p className={styles.page_description}>{dictionary["choose_your_option"] || "Choose your option - subscription or one-time purchase"}</p>
				<p className={styles.subtitle} dangerouslySetInnerHTML={{ __html: dictionary["one_generation_one_sec"] || "1 Generation / 1 sec video - <span>1 credit</span>" }}></p>
			</section>
			{initialPlansProps.initialPlans === null && (
				<div style={{ textAlign: "center", margin: "50px 0" }}>
					<Loading_ellipsis big={true} />
				</div>
			)}
			{initialPlansProps.initialPlans !== null && <PlansTable {...initialPlansProps} dictionary={dictionary} locale={locale} />}
			<FaqComponent dictionary={dictionary} pageName={"page_pricing"} />
		</Layout>
	);
}

export async function getServerSideProps({ locale, query }) {
	return { props: { locale, query } };
}
